import { APIClient } from '@frontend/api-utils';

export class ScreenEnumClient extends APIClient {
    public static readonly endpoint = '/wizard-api/v1';

    public static async fetchScreenTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/screen-types`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchScreenTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/screen-triggers`);
        return await this.handleResponse<string[]>(response);
    }
}
